import {Component, Input} from '@angular/core';
import { Post } from "../../../app/app.interfaces";

@Component({
  selector: 'post-taxonomies',
  templateUrl: 'post-taxonomies.html'
})

export class PostTaxonomies {
  @Input() post: Post;

}




// WEBPACK FOOTER //
// ./src/partials/post/post-taxonomies/post-taxonomies.ts